import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Initialize language based on URL path
    return window.location.pathname.startsWith('/ar') ? 'ar' : 'en';
  });

  useEffect(() => {
    // Update language when URL changes
    const handleRouteChange = () => {
      const newLang = window.location.pathname.startsWith('/ar') ? 'ar' : 'en';
      if (newLang !== language) {
        setLanguage(newLang);
      }
    };

    // Listen for browser back/forward navigation
    window.addEventListener('popstate', handleRouteChange);
    
    // Listen for React Router navigation by checking URL periodically
    const intervalId = setInterval(handleRouteChange, 100);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      clearInterval(intervalId);
    };
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};